import { render } from "./SmsPage.vue?vue&type=template&id=92b0a1ca"
import script from "./SmsPage.vue?vue&type=script&lang=js"
export * from "./SmsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__